import React from "react";
import Modal from "react-bootstrap/Modal";
import ReactToPrint from "react-to-print";
import ReactDropdown from "react-dropdown";
import InChoVayApi from "../../../service/inChoVayApi";
import handleEscapeKey from "utils/handleEscapeKey";
const ListCombo = {
  17: [
    {
      value: "TRABOTGOC",
      label: "TRABOTGOC",
    },
    {
      value: "TRABOTGOC1",
      label: "TRABOTGOC1",
    },
  ],
  21: [
    {
      value: "VAYTHEM",
      label: "VAYTHEM",
    },
    {
      value: "VAYTHEM1",
      label: "VAYTHEM1",
    },
  ],
};

class ComponentToPrint extends React.Component {
  render() {
    return (
      <div className="col-sm-12" style={{ width: "100%", color: "#000000" }}>
        <div
          style={{ padding: "15px" }}
          dangerouslySetInnerHTML={{ __html: this.props.data }}
        ></div>
      </div>
    );
  }
}
const ThuChiRow = ({ labelText, valueRow }) => (
  <div class="form-group row text-left" style={{ border: "none" }}>
    <div class="col-md-2  color7-bold" style={{ border: "none" }}>
      {labelText}
    </div>
    <div class="col-md-10 color7 " style={{ border: "none" }}>
      {valueRow}
    </div>
  </div>
);

class InPhieuThuChi extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: props.show || false, // Trạng thái popup
      printContent: "",
      thuChiId: 0,
      mauInId: 0,
      ListMauIn: [],
      PhieuThuChi: {},
      tenMauIn: "",
      ListMauPhieuIn: [],
      keyMauIn: "",
    };
    this.toggleModal = this.props.onHide.bind(this);
    // Tạo instance của useEscapeKey và gán vào this.escListener
    this.escListener = handleEscapeKey(this.props.onHide);
  }

  componentDidMount() {
    // Thêm listener chỉ khi modal mở
    if (this.state.isModalOpen) this.escListener.addListener();

    let { getDetailPhieuThuChi, show, inthuchi, onHide } = this.props;
    let { DetailPhieuThuChi, thuChiId } = inthuchi;
    if (thuChiId != -500) {
      if (show) {
        this.setState({
          thuChiId: thuChiId,
        });
        getDetailPhieuThuChi({ thuchiId: thuChiId });
        if (DetailPhieuThuChi.Type != undefined && DetailPhieuThuChi.Type > 0) {
          this.getComboMauIn(DetailPhieuThuChi.Type);
        }
      }
    } else {
      onHide();
    }
  }

  componentWillUnmount() {
    // Gỡ listener khi component unmount
    this.escListener.removeListener();
  }

  toggleModal() {
    // Cập nhật trạng thái popup và thêm/xóa listener khi cần
    this.setState(
      (prevState) => ({ isModalOpen: !prevState.isModalOpen }),
      () => {
        if (this.state.isModalOpen) {
          this.escListener.addListener();
        } else {
          this.escListener.removeListener();
        }
      }
    );
  }

  onHide = () => {
    this.setState({ isModalOpen: false });
    this.props.onHide();
  };

  componentDidUpdate() {
    let { show, inthuchi, getInPhieuThuChi, onHide } = this.props;
    let { PhieuThuChi } = this.state;
    let { DetailPhieuThuChi, thuChiId } = inthuchi;
    if (thuChiId != -500) {
      if (show && DetailPhieuThuChi !== PhieuThuChi) {
        let tenMauIn = DetailPhieuThuChi.TenMauIn;
        if (DetailPhieuThuChi.Type === 17) tenMauIn = "TRABOTGOC";
        if (DetailPhieuThuChi.Type === 21) tenMauIn = "VAYTHEM";
        this.setState({
          PhieuThuChi: DetailPhieuThuChi,
          tenMauIn,
        });
        if (DetailPhieuThuChi.Type != undefined && DetailPhieuThuChi.Type > 0) {
          this.getComboMauIn(DetailPhieuThuChi.Type);
        }
        // let { keyMauIn } = this.state;
        // getInPhieuThuChi({
        //   thuchiId: thuChiId,
        //   tenMauIn: keyMauIn,
        // });
      }
    } else {
      onHide();
    }
  }
  onChangeMauIn = () => (item) => {
    let { getInPhieuThuChi } = this.props;
    let { thuChiId, keyMauIn } = this.state;
    keyMauIn = item.value;
    this.setState({ keyMauIn });
    getInPhieuThuChi({
      tenMauIn: keyMauIn,
      thuchiId: thuChiId,
    });
  };

  getComboMauIn = (type) => {
    let { getInPhieuThuChi, inthuchi } = this.props;
    let { thuChiId } = inthuchi;
    InChoVayApi.comboMauPhieuThuChi(type).then((response) => {
      if (response.data.List) {
        let { ListMauPhieuIn, keyMauIn } = this.state;
        ListMauPhieuIn = response.data.List;
        keyMauIn = ListMauPhieuIn[0].value;
        this.setState({ ListMauPhieuIn, keyMauIn });
        getInPhieuThuChi({
          thuchiId: thuChiId,
          tenMauIn: keyMauIn,
        });
      }
    });
  };

  render() {
    let props = this.props;
    let { inThuChiLoading, onHide, show, inthuchi } = props;
    let { thuChiId } = inthuchi;
    let { DetailPhieuThuChi, InPhieuThuChi } = inthuchi;
    let {
      NguoiNop,
      SoTienThuChi,
      NgayThuChi,
      ThoiGianTao,
      NguoiTao,
      MaChoVay,
      ChiTiet,
      TenKhachHang,
      NgaySinh,
      DiaChi,
      NguoiThu,
      GhiChu,
      NoiDung,
      MaChungTu,
      MaNhanVay,
      KenhThanhToan,
      TenMauIn,
      Type,
      Value,
    } = DetailPhieuThuChi;
    let { tenMauIn, ListMauPhieuIn, keyMauIn } = this.state;
    setTimeout(() => {
      window
        .JsBarcode(".barcode")
        .options({
          width: 1,
          height: 26,
          margin: 0,
          fontSize: 15,
        })
        .init();
    }, 500);
    return (
      <Modal
        show={show}
        onHide={this.onHide}
        size="modal-new-size modal-new-size"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new modal fade text-left popup-detail"
      >
        <Modal.Header>
          <h4 className="modal-title color7-bold" id="myModalLabel16">
            <span className="btn-icon-right">
              <img src="/app-assets/images/icon-in-phieu-v2.png" />
            </span>
            <span style={{ marginLeft: "-20px", marginTop: "10px" }}>
              {" "}
              In phiếu
            </span>
          </h4>
          <button type="button" className="close-popup-new" onClick={onHide}>
            <i className="mdi mdi-close"></i>
          </button>
        </Modal.Header>
        <Modal.Body className="color-print">
          <div
            className={
              "loader loader-default " + (inThuChiLoading ? "is-active" : "")
            }
          ></div>
          <div class="form tat-toan form-horizontal form-edit">
            <div class="form-body">
              <div class="card collapse-icon accordion-icon-rotate">
                <div
                  style={{ paddingLeft: "10px" }}
                  class="card-header "
                  data-toggle="collapse"
                  href="#collapse19639"
                  aria-expanded="true"
                  aria-controls="collapse19639"
                >
                  <a class="card-title lead info collapsed" href={() => false}>
                    <h3>Chi tiết phiếu</h3>
                  </a>
                </div>
                <div
                  id="collapse19639"
                  role="tabpanel"
                  aria-labelledby="headingCollapse9639"
                  class="card-collapse collapse show"
                >
                  <div class="card-content">
                    <div class="card-body">
                      <div
                        className="row"
                        style={{ paddingLeft: "25px", paddingRight: "25px" }}
                      >
                        <br />
                        <div
                          class="col-sm-12 form-body form-bordered-1"
                          style={{
                            border: "1px solid #e9ebf5",
                            borderRadius: "10px",
                          }}
                        >
                          <div>
                            {Value < 0 && (
                              <ThuChiRow
                                labelText="Người nhận"
                                valueRow={NguoiNop}
                              ></ThuChiRow>
                            )}
                            {Value > 0 && (
                              <ThuChiRow
                                labelText="Người nộp"
                                valueRow={NguoiNop}
                              ></ThuChiRow>
                            )}
                            <ThuChiRow
                              labelText={
                                Value < 0 ? "Số tiền chi" : "Số tiền thu"
                              }
                              valueRow={SoTienThuChi}
                            ></ThuChiRow>

                            <ThuChiRow
                              labelText={Value < 0 ? "Ngày chi" : "Ngày thu"}
                              valueRow={NgayThuChi}
                            ></ThuChiRow>

                            <ThuChiRow
                              labelText={"Thời gian tạo"}
                              valueRow={ThoiGianTao}
                            ></ThuChiRow>
                            {/* <ThuChiRow
                              labelText={"Thời gian tạo"}
                              valueRow={ThoiGianTao}
                            ></ThuChiRow> */}
                            <ThuChiRow
                              labelText={"Người tạo"}
                              valueRow={NguoiTao}
                            ></ThuChiRow>
                            {MaChoVay && (
                              <ThuChiRow
                                labelText="Mã cho vay"
                                valueRow={MaChoVay}
                              ></ThuChiRow>
                            )}
                            {MaNhanVay && (
                              <ThuChiRow
                                labelText="Mã nhân vay"
                                valueRow={MaNhanVay}
                              ></ThuChiRow>
                            )}
                            {ChiTiet && (
                              <ThuChiRow
                                labelText="Chi tiết"
                                valueRow={ChiTiet}
                              ></ThuChiRow>
                            )}

                            {TenKhachHang && (
                              <ThuChiRow
                                labelText="Tên khách hàng"
                                valueRow={TenKhachHang}
                              ></ThuChiRow>
                            )}
                            {NgaySinh && (
                              <ThuChiRow
                                labelText="Ngày sinh"
                                valueRow={NgaySinh}
                              ></ThuChiRow>
                            )}
                            {DiaChi && (
                              <ThuChiRow
                                labelText=" Địa chỉ"
                                valueRow={DiaChi}
                              ></ThuChiRow>
                            )}
                            <ThuChiRow
                              labelText={Value < 0 ? "Người chi" : "Người thu"}
                              valueRow={NguoiThu}
                            ></ThuChiRow>
                            {GhiChu && (
                              <ThuChiRow
                                labelText="Ghi chú"
                                valueRow={GhiChu}
                              ></ThuChiRow>
                            )}
                            {NoiDung && (
                              <ThuChiRow
                                labelText="Nội dung"
                                valueRow={NoiDung}
                              ></ThuChiRow>
                            )}
                          </div>
                        </div>
                        <div style={{ display: "none" }}>
                          <ComponentToPrint
                            data={InPhieuThuChi}
                            ref={(el) => (this.componentRef = el)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="modal-footer">
          <div className="row col-md-12" style={{ justifyContent: "flex-end" }}>
            <div className=" footer-chon-phieu">
              {" "}
              <ReactDropdown
                onChange={this.onChangeMauIn()}
                options={ListMauPhieuIn}
                controlClassName="form-control input-sm ml-1 pad-col"
                value={keyMauIn}
              />
            </div>
            <div className=" text-right footer-in">
              <ReactToPrint
                trigger={() => {
                  // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
                  // to the root node of the returned component as it will be overwritten.
                  return (
                    <a class="btn btn-new-main btn-checknew" href={() => false}>
                      <span>
                        <i class="mdi mdi-printer"></i>
                      </span>{" "}
                      &nbsp; In phiếu&nbsp;
                    </a>
                  );
                }}
                content={() => this.componentRef}
                copyStyles={false}
              />
            </div>

            <div className="text-right footer-close" style={{marginLeft:"15px"}}>
              <button
                type="button"
                class="btn btn-new-main btn-closenew"
                onClick={onHide}
              >
                <span>
                  <i class="mdi mdi-close"></i>
                </span>
                &nbsp; Đóng&nbsp;
              </button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default InPhieuThuChi;
